import { render, staticRenderFns } from "./ForumLocation.vue?vue&type=template&id=5cec3d5e&"
import script from "./ForumLocation.vue?vue&type=script&lang=js&"
export * from "./ForumLocation.vue?vue&type=script&lang=js&"
import style0 from "./ForumLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports